import i18n from '@/utils/i18n';
import React from 'react';
import { AppPageLayout } from '@experiences/templates/app-page-layout';
import { CustomersContent } from '@finance-hub/domain/customers/containers/customers-content';
import { FINANCE_HUB_ROUTES } from '@/navigators/routes';
import { FinanceHubBreadcrumb } from '@finance-hub/components/finance-hub-breadcrumb';
import { FinanceHubCustomersStackParams } from '@/navigators/types';
import { FinanceHubShellTemplate } from '@finance-hub/templates/finance-hub-shell-template';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  FinanceHubCustomersStackParams,
  typeof FINANCE_HUB_ROUTES.Customers
>;

export const CustomersScreen: React.FC<Props> = () => (
  <FinanceHubShellTemplate>
    <AppPageLayout
      leadingActions={
        <FinanceHubBreadcrumb title={i18n.t('finance_hub.customers.title')} />
      }
      scroll={false}
    >
      <CustomersContent />
    </AppPageLayout>
  </FinanceHubShellTemplate>
);
